<img [class]="class" [src]="_safeUrl"/>
